"use client";
import { compareUrls } from "@intlayer/editor";
import { useEffect } from "react";
import { useCommunicator } from "./CommunicatorContext.mjs";
const useCrossFrameMessageListener = (key, onEventTriggered, revalidator) => {
  const { allowedOrigins, postMessage, senderId } = useCommunicator();
  useEffect(() => {
    if (onEventTriggered) {
      const handleMessage = (event) => {
        const { type, data, senderId: msgSenderId } = event.data;
        if (type !== key) return;
        if (msgSenderId === senderId) return;
        if (typeof allowedOrigins === "undefined" || allowedOrigins?.some((url) => compareUrls(url, event.origin)) || allowedOrigins?.includes("*")) {
          onEventTriggered(data);
        }
      };
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    }
  }, [allowedOrigins, postMessage, senderId, revalidator]);
  const postMessageWrapper = (data) => {
    postMessage({ type: key, data, senderId });
  };
  return postMessageWrapper;
};
export {
  useCrossFrameMessageListener
};
//# sourceMappingURL=useCrossFrameMessageListener.mjs.map